import { render } from "./gzhdlistnum.vue?vue&type=template&id=288f3bbf"
import script from "./gzhdlistnum.vue?vue&type=script&lang=js"
export * from "./gzhdlistnum.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__